import { HttpParams } from '@angular/common/http';
import { AbstractParams } from './abstract-params';

export abstract class BaseParams<T, I> extends AbstractParams<T, I> {
  static STRING_SYMBOL = `'`;

  protected static parseParamStr(value: any) {
    if (typeof value === 'object') {
      if (value instanceof Date) {
        value = [
          [
            value.getUTCFullYear(),
            String(value.getUTCMonth() + 1).padStart(2, '0'),
            String(value.getUTCDate()).padStart(2, '0'),
          ].join('-'),
          [
            [
              String(value.getUTCHours()).padStart(2, '0'),
              String(value.getUTCMinutes()).padStart(2, '0'),
              String(value.getUTCSeconds()).padStart(2, '0'),
            ].join(':'),
            String(value.getUTCMilliseconds()).padStart(3, '0'),
          ].join('.'),
        ].join(' ');
        value = `TIMESTAMP ${BaseParams.STRING_SYMBOL}${value}${BaseParams.STRING_SYMBOL}`;
      } else {
        value = JSON.stringify(value);
      }
    } else if (typeof value === 'symbol') {
      value = value.toString();
      value = value.replace('Symbol(', '');
      value = value.replace(/\)$/g, '');
    } else if (typeof value !== 'string') {
      value = String(value);
    }

    return value;
  }

  toHttpParams() {
    let params = new HttpParams();

    this._handleParamsAdapter({
      has(key: string) {
        return params.has(key);
      },

      set(key: string, param: string) {
        params = params.set(key, param);
      },
    });

    return params;
  }

  toBodyParams() {
    let params: any = {};

    this._handleParamsAdapter({
      has(key: string) {
        return !!params[key];
      },

      set(key: string, param: string) {
        params[key] = param;
      },
    });

    return params;
  }

  protected abstract _handleParamsAdapter(
    paramsAdapter: ISetParamsAdapter
  ): void;
}

export interface ISetParamsAdapter {
  has(key: string): boolean;
  set(key: string, param: string): void;
}
